<template>
  <!-- 风格14 -->
  <div class="v14-style" :style="getStyleContainerStyle()" @click="handleClick">
    <img class="header-bg" src="@/assets/img/style14/header_bg.png" v-if="!isMobile" />
    <div class="header-left" v-if="!isMobile">
      <div class="header-middle-filter"></div>
      <div
        class="header-ProjectName"
        :style="{
          fontSize: $w_Ratio(38, $store) + 'px',
        }"
      >
        <p>{{ $store.state.ProjectInfo.Name }}</p>
      </div>
    </div>
    <div class="header-right" v-if="!isMobile">
      <div class="time" :style="{ fontSize: $w_Ratio(28, $store) + 'px' }">{{ timeStr }}</div>
      <div class="date-info" :style="{ fontSize: $w_Ratio(15, $store) + 'px' }">
        <div class="date">{{ dateStr }}</div>
        <div class="week">{{ week }}</div>
      </div>
    </div>
  </div>

  <!-- 手机端 -->
  <img class="header-bg" src="@/assets/img/mobile/style3/header_bg.png" v-if="isMobile" />

  <div class="header-middle" v-if="isMobile">
    <div class="header-middle-filter"></div>
    <div
      class="header-ProjectName"
      :style="{
        fontSize: $w_Ratio(26, $store) + 'px',
      }"
    >
      <p>{{ $store.state.ProjectInfo.Name }}</p>
    </div>

    <div class="spotlight-ct">
      <div class="spotLight1"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import jsonp from 'jsonp';
export default {
  name: 'V14Style',
  components: {},
  props: {
    Configuration: Object,
    ProjectInfo: Object,
  },
  data() {
    return {
      style: {
        height: 96,
      },
      timeStr: '',
      week: '',
      dateStr: '',
      timeString: '',
      dateString: '',
      cityName: '',
      city: '',
      humidity: '',
      temperature: '',
      temperaturemin: '',
      temperaturemax: '',
      weather: '',
      headerLon: '',
      headerLat: '',
      weatherIcon: '',
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function (val) {
        this.headerLon = val.propertyData.headerLngLatData.value.lon;
        this.headerLat = val.propertyData.headerLngLatData.value.lat;
        this.onConfigurationChange();
      },
    },
  },
  created() {
    this.onConfigurationChange();
    // this.autoGetTime();
  },
  mounted() {
    this.headerLon = this.Configuration.propertyData?.headerLngLatData?.value?.lon;
    this.headerLat = this.Configuration.propertyData?.headerLngLatData?.value?.lat;

    this.updateTime();
    setInterval(() => this.updateTime(), 1000);

    this.getWeather();
  },
  methods: {
    handleJump(url) {
      if (url) {
        window.open(url);
      } else {
        this.$ElMessage.warning('请配置地址！');
      }

      console.log('跳转地址', url);
    },
    selectLeftItem(index) {
      this.selectedLeftIndex = index;
      this.selectedRightIndex = null; // 取消右侧的选中
    },
    updateTime() {
      const now = new Date();
      // 时间格式：HH:MM:SS
      this.timeStr = `${now.getHours().toString().padStart(2, '0')}:${now
        .getMinutes()
        .toString()
        .padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
      // 星期映射
      const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      this.week = weeks[now.getDay()];
      // 日期格式：YYYY-MM-DD
      this.dateStr = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now
        .getDate()
        .toString()
        .padStart(2, '0')}`;
    },
    selectRightItem(index) {
      this.selectedRightIndex = index;
      this.selectedLeftIndex = null; // 取消左侧的选中
    },

    onConfigurationChange() {
      this.style.backgroundColor = this.Configuration.propertyData.headerBackgroundColor.value;
      this.cityName = this.Configuration.propertyData.cityName.value;
    },
    getNoWeather(weather) {
      let weat = '';
      if (weather == 'CLEAR_DAY') weat = '晴';
      else if (weather == 'CLEAR_NIGHT') weat = '晴';
      else if (weather == 'CLOUDY') weat = '阴';
      else if (weather == 'PARTLY_CLOUDY_DAY' || weather == 'PARTLY_CLOUDY_NIGHT' || weather == 'CLOUDY')
        weat = '多云';
      else if (weather == 'LIGHT_RAIN' || weather == 'MODERATE_RAIN') weat = '小雨';
      else if (weather == 'STORM_RAIN' || weather == 'STORM_RAIN') weat = '大雨';
      else if (weather == 'FOG') weat = '雾';
      else if (weather == 'LIGHT_SNOW' || weather == 'MODERATE_SNOW') weat = '小雪';
      else if (weather == 'HEAVY_SNOW' || weather == 'STORM_SNOW') weat = '大雪';
      else weat = '晴';
      return weat;
    },
    getNoWeatherIcon(weather) {
      let weat = '';
      if (weather == 'CLEAR_DAY') weat = 'wi-day-sunny';
      else if (weather == 'CLEAR_NIGHT') weat = 'wi-day-sunny';
      else if (weather == 'CLOUDY') weat = 'wi-cloud';
      else if (weather == 'PARTLY_CLOUDY_DAY' || weather == 'PARTLY_CLOUDY_NIGHT' || weather == 'CLOUDY')
        weat = 'wi-cloudy';
      else if (weather == 'LIGHT_RAIN' || weather == 'MODERATE_RAIN') weat = 'wi-showers';
      else if (weather == 'STORM_RAIN' || weather == 'STORM_RAIN') weat = 'wi-rain-mix';
      else if (weather == 'FOG') weat = 'wi-fog';
      else if (weather == 'LIGHT_SNOW' || weather == 'MODERATE_SNOW') weat = 'wi-snowflake-cold';
      else if (weather == 'HEAVY_SNOW' || weather == 'STORM_SNOW') weat = 'wi-snowflake-cold';
      else weat = 'wi-day-sunny';
      return weat;
    },
    getWeather() {
      let hourUrl = `https://api.caiyunapp.com/v2.6/N37HqKfCQajpg5mY/${this.headerLon},${this.headerLat}/daily?dailysteps=1`;
      jsonp(hourUrl, (err, res) => {
        if (!err) {
          console.log(res, '4353534534534534');

          const { precipitation, temperature, wind, skycon, humidity } = res.result.daily;

          this.rainfall = precipitation[0].value;
          // this.temperature = temperature[0].value;
          this.temperaturemax = temperature[0].max;
          this.temperaturemin = temperature[0].min;
          this.windpower = wind[0].speed;
          this.weather = skycon[0].value;
          this.humidity = humidity[0].value;

          this.weatherIcon = this.weather;
        }
      });
    },
    getAirquality(aqi) {
      let alldata = Number(aqi);
      let airQualityLevel = '';
      if (alldata <= 50) airQualityLevel = '优';
      else if (alldata <= 100) airQualityLevel = '良';
      else if (alldata <= 150) airQualityLevel = '轻度污染';
      else if (alldata <= 200) airQualityLevel = '中度污染';
      else if (alldata <= 300) airQualityLevel = '重度污染';
      else airQualityLevel = '良';
      return airQualityLevel;
    },
    getHeaderInfopStyle(fs = 14, pt = 15) {
      return {
        paddingTop: this.$h_Ratio(pt, this.$store) + 'px',
        fontSize: this.$w_Ratio(fs, this.$store) + 'px',
        // transform: `scale(${this.$w_Ratio(1, this.$store)})`,
      };
    },
    getStyleContainerStyle() {
      return {
        height: this.$h_Ratio(this.style.height, this.$store) + 'px',
        backgroundColor: this.style.backgroundColor,
      };
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
    autoGetTime() {
      let padaDate = function (value) {
        // 时间不足十补零
        return value < 10 ? '0' + value : value;
      };
      setInterval(() => {
        const date = new Date();
        // console.log(date);
        const year = date.getFullYear(); //存储年
        const month = padaDate(date.getMonth() + 1); //存储月份
        const day = padaDate(date.getDate()); //存储日期
        const hours = padaDate(date.getHours()); //存储时
        const minutes = padaDate(date.getMinutes()); //存储分
        const seconds = padaDate(date.getSeconds()); //存储秒
        //返回格式化后的日期
        this.dateString = year + 'D' + month + 'D' + day;
        this.timeString = hours + 'T' + minutes + 'T' + seconds;
      }, 1000);
    },
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
    }),
  },
  Configuration: {
    componentTitle: '智域云屏',
    componentName: 'V14Style',
    componentOverViewImg: './img/styles/style14.png',
    backgroundImg: './img/backgrounds/background_img/V14.png',
    backgroundImgMobile: `./img/backgrounds/background_img/mobile/V4.png`,
    propertyData: {
      cityName: {
        propertyComponentName: 'SingleInputor',
        value: '杭州',
        lable: '定位城市',
      },
      headerLngLatData: {
        propertyComponentName: 'MapLatLon',
        value: {
          lon: '120.15',
          lat: '30.28',
        },
      },
      headerBackgroundColor: {
        propertyComponentName: 'SingleColorSelector',
        value: 'rgba(25, 36, 45, 0)',
        lable: '头部背景颜色',
      },
      menuStyle: {
        value: {
          height: 75,
          width: 700,
        },
      },
      headerLngLatData: {
        propertyComponentName: 'MapLatLon',
        value: {
          lon: '120.15',
          lat: '30.28',
        },
      },
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import url('../../../assets/css/weather-icons.min.css');
@import url('../../../assets/css/weather-icons-wind.min.css');
@font-face {
  font-family: 'DS-DIGIT';
  src: url('../../../assets/font/DS-DIGIT.TTF') format('truetype');
  font-weight: normal;
  font-style: normal;
}
.v14-style {
  z-index: 99;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  color: #01f0f9;
  display: flex;
  justify-content: space-between;
  .header-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    margin: 0;
    padding: 0;
    object-fit: cover;
  }
  .header-left {
    width: 32%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    color: #fff;
    .header-ProjectName {
      width: 100%;
      height: 100%;
      position: absolute;
      font-weight: 700;
      top: 0;
      display: flex;
      justify-content: center;
      letter-spacing: 6px;
      align-items: center;
      color: #ffffff;
      p {
        margin: 0;
        background: linear-gradient(to bottom, #ffffff 30%, #e1e3e4 66%, #d3e6ee 100%);
        background-clip: text;
        -webkit-background-clip: text;
        color: transparent;
      }
    }
  }

  .header-middle {
    width: 56%;
    height: 100%;
    flex-shrink: 1;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }
    .header-ProjectName {
      width: 100%;
      height: 100%;
      position: absolute;
      font-weight: 700;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;

      p {
        margin: 0;
        /* background: linear-gradient(to bottom, #ffffff 30%, #eeeff0 66%, #d9eaf7 100%); */
        background-clip: text;
        -webkit-background-clip: text;
        color: transparent;
      }
    }
    .spotlight-ct {
      position: absolute;
      bottom: 2%;
      left: 50%;
      transform: translateX(-49.5%);
      width: 90%;
      height: 40%;
      overflow: hidden;
      .spotLight1 {
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 28%;
        height: 20%;
        transform: translate(-50%, -50%);
        background: radial-gradient(
          ellipse at center,
          rgba(189, 91, 87, 0) 0%,
          #13d6c6 12%,
          rgba(189, 91, 87, 0) 60%,
          rgba(189, 91, 87, 0) 69%
        );
        animation: titlelight 6s infinite cubic-bezier(0.74, 0.57, 0.5, 0.9);
      }

      .spotLight2 {
        background: radial-gradient(
          ellipse at center,
          rgba(189, 91, 87, 0) 0%,
          rgb(0, 255, 242) 9%,
          rgba(189, 91, 87, 0) 75%,
          rgba(189, 91, 87, 0) 73%
        );
        width: 9%;
        height: 20%;
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 11%;
        height: 14%;
        transform: translate(-50%, -50%);
        animation: titlelight 6s infinite cubic-bezier(0.74, 0.57, 0.5, 0.9);
      }
    }
  }

  .header-right {
    width: 12%;
    height: 80%;
    display: flex;
    align-items: center;
    color: white;
    font-family: Arial, sans-serif;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
    .header-bg {
      width: 100%;
      position: absolute;
      top: 0;
    }
    .date-info {
      width: 100%;
      display: flex;
      align-items: center;
      background: linear-gradient(to bottom, #ffffff 0%, #c2e4ff 6%, #ffffff 99%);
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
    }
    .time {
      font-family: 'DS-DIGIT', 'Courier New', monospace;
      letter-spacing: 2px;
      font-weight: bolder;
      background: linear-gradient(to bottom, #ffffff 0%, #c2e4ff 6%, #ffffff 99%);
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
    }
    .date {
      font-family: 'DS-DIGIT', 'Courier New', monospace;
      letter-spacing: 1px;
      font-weight: bolder;
      background: linear-gradient(to bottom, #ffffff 0%, #c2e4ff 6%, #ffffff 99%);
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
    }
    .week {
      font-weight: bolder;
      margin-left: 6px;
    }
  }
}
.icon {
  margin-right: 25px;

  img {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
}
.icon2 {
  margin-left: 0;
}
</style>
